export interface GameQuestion {
  id: string;
  title: string;
  sceneId: string;
  sceneName: string;
  type: "single" | "judge" | "image";
  difficulty: "easy" | "medium" | "hard";
  answer: string;
  options: string[];
  explanation: string;
  enabled: boolean;
}

export interface GameLevel {
  id: string;
  name: string;
  questions: string[];
  unlockCondition: string;
  rewardPoints: number;
  sceneId: string;
}

export interface GameTitle {
  id: string;
  name: string;
  icon: string;
  condition: string;
  description: string;
  unlocked: number;
  total: number;
}

export interface PointRule {
  action: string;
  points: number;
  description: string;
}

export const gameStats = {
  totalQuestions: 86,
  totalLevels: 12,
  totalTitles: 18,
};

export const gameQuestions: GameQuestion[] = [
  { id: "1", title: "三峡大坝坝高多少米？", sceneId: "2", sceneName: "三峡大坝", type: "single", difficulty: "easy", answer: "B", options: ["A. 175米", "B. 185米", "C. 195米", "D. 200米"], explanation: "三峡大坝坝高185米，正常蓄水位175米。", enabled: true },
  { id: "2", title: "西陵峡全长约多少公里？", sceneId: "1", sceneName: "西陵峡口", type: "single", difficulty: "easy", answer: "B", options: ["A. 56公里", "B. 66公里", "C. 76公里", "D. 86公里"], explanation: "西陵峡是三峡中最长的峡谷，全长66公里。", enabled: true },
  { id: "3", title: "葛洲坝于哪一年全面建成？", sceneId: "3", sceneName: "葛洲坝", type: "single", difficulty: "medium", answer: "C", options: ["A. 1978年", "B. 1979年", "C. 1981年", "D. 1983年"], explanation: "葛洲坝水利枢纽于1981年全面建成。", enabled: true },
  { id: "4", title: "三游洞得名于哪三位诗人？", sceneId: "6", sceneName: "三游洞", type: "single", difficulty: "medium", answer: "A", options: ["A. 白居易、白行简、元稹", "B. 李白、杜甫、白居易", "C. 苏轼、黄庭坚、米芾", "D. 王维、孟浩然、李白"], explanation: "三游洞因唐代白居易、白行简、元稹三人同游而得名。", enabled: true },
  { id: "5", title: "三峡大坝总装机容量为多少万千瓦？", sceneId: "2", sceneName: "三峡大坝", type: "single", difficulty: "hard", answer: "D", options: ["A. 1250万千瓦", "B. 1750万千瓦", "C. 2000万千瓦", "D. 2250万千瓦"], explanation: "三峡大坝总装机容量为2250万千瓦，是目前世界上最大的水电站。", enabled: true },
  { id: "6", title: "黄牛岩传说中是谁的神牛？", sceneId: "4", sceneName: "黄牛岩", type: "single", difficulty: "medium", answer: "B", options: ["A. 黄帝", "B. 大禹", "C. 炎帝", "D. 尧帝"], explanation: "相传大禹治水时神牛助其开山，黄牛岩因此得名。", enabled: true },
  { id: "7", title: "石牌保卫战发生在哪次战争中？", sceneId: "5", sceneName: "石牌要塞", type: "single", difficulty: "hard", answer: "B", options: ["A. 甲午战争", "B. 抗日战争", "C. 解放战争", "D. 抗美援朝"], explanation: "石牌保卫战是二战时期（抗日战争）著名的战役。", enabled: true },
  { id: "8", title: "白帝城与哪位历史人物有关？", sceneId: "11", sceneName: "白帝城", type: "single", difficulty: "easy", answer: "A", options: ["A. 刘备", "B. 曹操", "C. 孙权", "D. 诸葛亮"], explanation: "白帝城是刘备托孤之地，与三国历史密切相关。", enabled: true },
  { id: "9", title: "巫山神女峰的传说主角是谁？", sceneId: "12", sceneName: "巫山神女峰", type: "single", difficulty: "medium", answer: "C", options: ["A. 嫦娥", "B. 织女", "C. 瑶姬", "D. 西王母"], explanation: "巫山神女峰传说主角是瑶姬，相传为炎帝之女。", enabled: true },
  { id: "10", title: "屈原故里位于哪个县？", sceneId: "8", sceneName: "屈原故里", type: "single", difficulty: "easy", answer: "B", options: ["A. 宜昌县", "B. 秭归县", "C. 兴山县", "D. 巴东县"], explanation: "屈原故里位于湖北省秭归县。", enabled: true },
  { id: "11", title: "三峡大坝总库容为多少亿立方米？", sceneId: "2", sceneName: "三峡大坝", type: "single", difficulty: "hard", answer: "C", options: ["A. 293亿", "B. 343亿", "C. 393亿", "D. 443亿"], explanation: "三峡大坝总库容为393亿立方米。", enabled: true },
  { id: "12", title: "三峡大坝是目前世界上最大的水利枢纽工程", type: "judge", sceneId: "2", sceneName: "三峡大坝", difficulty: "easy", answer: "正确", options: ["正确", "错误"], explanation: "三峡大坝确实是目前世界上最大的水利枢纽工程。", enabled: true },
];

export const gameLevels: GameLevel[] = [
  { id: "1", name: "初入三峡", questions: ["1", "2", "10"], unlockCondition: "完成上船初始配对", rewardPoints: 100, sceneId: "1" },
  { id: "2", name: "西陵探秘", questions: ["3", "4", "6"], unlockCondition: "到达西陵峡口", rewardPoints: 150, sceneId: "1" },
  { id: "3", name: "大坝巡礼", questions: ["5", "7", "11"], unlockCondition: "到达三峡大坝", rewardPoints: 200, sceneId: "2" },
  { id: "4", name: "历史长廊", questions: ["8", "9", "12"], unlockCondition: "到达石牌要塞", rewardPoints: 180, sceneId: "5" },
];

export const gameTitles: GameTitle[] = [
  { id: "1", name: "两坝一峡通关", icon: "ri-medal-line", condition: "完成所有关卡", description: "通关全部互动游戏关卡", unlocked: 234, total: 384 },
  { id: "2", name: "江豚守护者", icon: "ri-ship-line", condition: "答对10道环保题", description: "了解并保护长江生态", unlocked: 189, total: 384 },
  { id: "3", name: "三峡通", icon: "ri-ancient-gate-line", condition: "答对50道题", description: "累计答对50道题目", unlocked: 156, total: 384 },
  { id: "4", name: "摄影达人", icon: "ri-camera-line", condition: "使用5个换脸模板", description: "使用5个以上换脸模板", unlocked: 312, total: 384 },
  { id: "5", name: "知识王者", icon: "ri-trophy-line", condition: "答对20道难题", description: "累计答对20道困难题目", unlocked: 87, total: 384 },
  { id: "6", name: "收藏家", icon: "ri-folder-image-line", condition: "生成10张换脸照", description: "累计生成10张换脸照片", unlocked: 245, total: 384 },
];

export const pointRules: PointRule[] = [
  { action: "答对题目", points: 10, description: "每答对一道题目" },
  { action: "打卡景点", points: 20, description: "每到达一个景点触发点" },
  { action: "分享报告", points: 50, description: "分享旅游报告到社交媒体" },
  { action: "使用换脸", points: 15, description: "每生成一张换脸照片" },
  { action: "连续答题", points: 30, description: "连续答对3道题" },
  { action: "完成关卡", points: 100, description: "完成一个游戏关卡" },
];